module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/azure/azure.component.html
// module id = ./src/app/azure/azure.component.html
// module chunks = main